export class Details {
    value() {
        return [];
    }
}